import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { PartnershipsPage } from 'src/pages/partnerships';
import {
  PeoPayrollProviderDetailBillingPage,
  PeoPayrollProviderDetailCompanyInformationPage,
  PeoPayrollProviderDetailEmployeesPage,
  PeoPayrollProviderDetailEmployersPage,
  PeoPayrollProviderDetailLiveStatusPage,
  PeoPayrollProviderDetailPeosPage,
  PeoPayrollProviderDetailSettingsPage,
  PeoPayrollProviderDetailStaffPage,
} from 'src/pages/peoPayrollProviders';
import {
  PeoDetailBillingPage,
  PeoDetailEmployeesPage,
  PeoDetailEmployersPage,
  PeoDetailLiveStatusPage,
  PeoDetailSettingsPage,
  PeoDetailStaffPage,
} from 'src/pages/peos';
import { PeoDetailCompanyInformationPage } from 'src/pages/peos/PeoDetailCompanyInformationPage';
import { RouteProps } from 'src/types/router';

import { PeoPayrollProvidersDetailOutlet } from '../peoPayrollProviders/components';

import { PeoPartnershipsDetailOutlet } from './components';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <PartnershipsPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.partnerships.detail.index,
    element: <Outlet />,
    accessRoles: [ReactRouteAccessKey.inherit],
    childRoutes: [
      {
        path: appRoutes.partnerships.detail.peo.index,
        element: <PeoPartnershipsDetailOutlet />,
        accessRoles: [ReactRouteAccessKey.inherit],
        childRoutes: [
          {
            path: appRoutes.partnerships.detail.peo.companyInformation,
            element: <PeoDetailCompanyInformationPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peo.billing,
            element: <PeoDetailBillingPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peo.staff,
            element: <PeoDetailStaffPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peo.employers,
            element: <PeoDetailEmployersPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peo.employees,
            element: <PeoDetailEmployeesPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peo.settings,
            element: <PeoDetailSettingsPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peo.liveStatus,
            element: <PeoDetailLiveStatusPage />,
            accessRoles: [ReactRouteAccessKey.isPlatformAdmin],
          },
        ],
      },
      {
        path: appRoutes.partnerships.detail.peoPayrollProvider.index,
        element: <PeoPayrollProvidersDetailOutlet />,
        accessRoles: [ReactRouteAccessKey.inherit],
        childRoutes: [
          {
            path: appRoutes.partnerships.detail.peoPayrollProvider.companyInformation,
            element: <PeoPayrollProviderDetailCompanyInformationPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peoPayrollProvider.billing,
            element: <PeoPayrollProviderDetailBillingPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peoPayrollProvider.staff,
            element: <PeoPayrollProviderDetailStaffPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peoPayrollProvider.peos,
            element: <PeoPayrollProviderDetailPeosPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peoPayrollProvider.employers,
            element: <PeoPayrollProviderDetailEmployersPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peoPayrollProvider.employees,
            element: <PeoPayrollProviderDetailEmployeesPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peoPayrollProvider.settings,
            element: <PeoPayrollProviderDetailSettingsPage />,
            accessRoles: [ReactRouteAccessKey.inherit],
          },
          {
            path: appRoutes.partnerships.detail.peoPayrollProvider.liveStatus,
            element: <PeoPayrollProviderDetailLiveStatusPage />,
            accessRoles: [ReactRouteAccessKey.isPlatformAdmin],
          },
        ],
      },
    ],
  },
];

export const PARTNERSHIPS_ROUTE: RouteProps = {
  path: appRoutes.partnerships.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.hasPlatformRoles],
};
